// this is a template that manages both advisory and gallery vehicle.

import * as React from "react"
import { useState, useEffect, useRef } from "react"
import { graphql } from "gatsby"
import { Layout } from "../../components/layout"
import {
  emaContainer,
  saumlContainer,
  listingContainerStyle,
  testmaincontainer,
  sPad,
  imgPad,
  mandatpad,
  subsectionTitles,
  test,
  testcontainer,
  PDPAuthor,
  ArtworkName,
  specification,
  pdpUrl,
  pdpImageslider,
  pdpSubheading,
  artistItem,
  artistImage,
  artworkImages,
  bluedDarkbutton,
  AddToCartContainer,
  SliderContainer,
  thumbnailSliderWrapper,
  containerMedia,
  colMedia,
  productContainer,
  colProduct,
  hrSpec,
  soldOut,
  auctionCardsContainer,
  auctionCard,
} from "../products/single-product.module.css"
import { blueDarkbutton } from "../artists/single-artist.module.css"
import { tooltip, tooltiptext, tooltipImage } from "./all-products.module.css"
import { title, sectionMandatPad } from "../../pages/index.module.css"
import { Link } from "gatsby"
import { DarkButton } from "../../components/buttons/dark-button"
import { ProductButton } from "../../components/buttons/product-button"
import ShopifyRichText from "../../utils/ShopifyRichTextToHTML"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
// import { Guide } from "../../components/guide";
import { AdvisoryFormLightbox } from "../../components/forms/advidoryForm"
import { GalleryFormLightbox } from "../../components/forms/galleryForm"
import { AddToCart } from "../../components/add-to-cart"
import { NumericInput } from "../../components/numeric-input"
// import { TextSnippet } from "@mui/icons-material"
// import { faGalacticSenate } from "@fortawesome/free-brands-svg-icons"
import { Seo } from "../../components/seo"
import { useSeekaConverge } from "@seeka-labs/converge-react"

export default function GalleryContent({ data, pageContext }) {
  // Render the component content
  const product = data.storefront.products.nodes.find(
    (node) => node.handle === pageContext.handle
  )

  if (!product) {
    return (
      <Layout>
        <p>Product not found.</p>
      </Layout>
    )
  }

  const artists = data.storefront.metaobjects.edges
  const productVendor = product.vendor
  const [sliderContainerStyle, setSliderContainerStyle] = useState({})
  const [quantity, setQuantity] = React.useState(1)
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  const sliderRef1 = useRef(null)
  const sliderRef2 = useRef(null)

  useEffect(() => {
    setNav1(sliderRef1.current)
    setNav2(sliderRef2.current)
  }, [])

  const productImages = product.images.nodes
  const showThumbnailSlider = productImages.length > 1

  useEffect(() => {
    const numProducts = data.storefront.products.nodes.filter(
      (product) =>
        product.vendor === productVendor &&
        product.handle !== pageContext.handle &&
        product.metafield?.reference?.fields[0]?.value !== "Advisory-Hidden"
    ).length

    if (numProducts >= 2) {
      setSliderContainerStyle({ width: "auto" })
    } else {
      setSliderContainerStyle({ width: "max-content" })
    }
  }, [data.storefront.products.nodes, productVendor, pageContext.handle])

  const numFilteredProducts = data.storefront.products.nodes.filter(
    (product) =>
      product.vendor === productVendor &&
      product.handle !== pageContext.handle &&
      product.metafield?.reference?.fields[0]?.value !== "Advisory-Hidden"
  ).length

  // Define an array of possible slidesToShow values
  const slidesToShowOptions = [4, 3, 2, 1]

  // Determine the appropriate slidesToShow value based on the number of products
  let slidesToShow =
    slidesToShowOptions.find((option) => numFilteredProducts >= option) || 1

  // Custom component for Previous Arrow
  const PrevArrow = (props) => {
    const { onClick } = props
    return (
      <button onClick={onClick} className="custom-slick-prev">
        &larr;
      </button>
    )
  }

  // Custom component for Next Arrow
  const NextArrow = (props) => {
    const { onClick } = props
    return (
      <button onClick={onClick} className="custom-slick-next">
        &rarr;
      </button>
    )
  }

  const sliderSettings = {
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    infinite: true,
    adaptiveHeight: false,
    autoplay: true,
    dots: false,
    speed: 1000,
    autoplaySpeed: 10000,
    draggable: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
        },
      },
    ],
  }

  const productSliderSettings = {
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    dots: true,
    speed: 1000,
    autoplaySpeed: 10000,
    adaptiveHeight: true,
    draggable: true,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
    ],
    asNavFor: showThumbnailSlider ? nav2 : null,
  }

  const thumbnailSliderSettings = {
    slidesToShow: productImages.length === 2 ? 2 : 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: productImages.length === 2 ? 2 : 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 0,
        },
      },
    ],
    asNavFor: showThumbnailSlider ? nav1 : null,
  }

  const productMetafields = product.metafields.filter(
    (metafield) => metafield !== null
  )
  productMetafields.forEach((metafield) => {
    if (
      metafield &&
      metafield.reference &&
      metafield.reference.fields &&
      metafield.reference.fields.length > 0
    ) {
      const textValue = metafield.reference.fields[0]?.value

      // console.log("Text Value:", textValue);

      const imageReference = metafield.reference.fields.find(
        (field) => field.reference && field.reference.id.includes("MediaImage")
      )
      const videoReference = metafield.reference.fields.find(
        (field) => field.reference && field.reference.id.includes("Video")
      )

      if (
        imageReference &&
        imageReference.reference &&
        imageReference.reference.image
      ) {
        const imageURL = imageReference.reference.image.url
        // console.log("Image URL:", imageURL);
      }

      if (
        videoReference &&
        videoReference.reference &&
        videoReference.reference.sources &&
        videoReference.reference.sources.length > 0
      ) {
        const videoURL = videoReference.reference.sources[0].url
        const videoAlt = videoReference.reference.alt
        // console.log("Video URL:", videoURL);
        // console.log("Video ALT:", videoAlt);
      }
    }
  })

  const getProductLink = (product) => {
    if (
      product.metafield &&
      product.metafield.reference &&
      product.metafield.reference.fields[0].value
    ) {
      const productType =
        product.metafield.reference.fields[0].value.toLowerCase()
      const productId = product.id.replace("gid://shopify/Product/", "") // Extract product ID
      const sku =
        product.variants.nodes.length > 0 ? product.variants.nodes[0].sku : null

      // Check if the product type is "advisory"
      if (productType === "advisory") {
        // Construct the link without including the product ID
        return `/${productType}/products/${product.handle}${
          sku ? `/${sku}` : ""
        }`
      } else {
        // Construct the link including the product ID
        return `/${productType}/products/${productId}/${product.handle}${
          sku ? `/${sku}` : ""
        }`
      }
    } else {
      // Construct the link for products without a specified type
      const productId = product.id.replace("gid://shopify/Product/", "") // Extract product ID
      const sku =
        product.variants.nodes.length > 0 ? product.variants.nodes[0].sku : null

      return `/products/${productId}/${product.handle}${sku ? `/${sku}` : ""}`
    }
  }

  // Filter the artist list based on matching names with product vendor
  const matchingArtists = artists.filter(({ node }) => {
    return node.artistname.value === productVendor
  })

  const matchingCollection = data.storefront.collections.nodes.find(
    (collection) => {
      return collection.title.toLowerCase() === productVendor.toLowerCase()
    }
  )

  function shuffleArray(array) {
    const shuffledArray = [...array]
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ]
    }
    return shuffledArray
  }

  const [randomArtists, setRandomArtists] = useState([])

  useEffect(() => {
    const shuffledArtists = shuffleArray(artists)
    setRandomArtists(shuffledArtists.slice(0, 5))
  }, [artists])

  const { metafield } = product
  // console.log(productMetafields);
  // console.log("product.metafield?.reference?.fields[0]?.value:", product.metafield?.reference?.fields[0]?.value);

  // const [selectTemplate, setSelectTemplate] = useState('');

  // useEffect(() => {
  //   // Fetch and set the select_template value when component mounts
  //   if (product && product.metafield && product.metafield.value) {
  //     setSelectTemplate(product.metafield.value);
  //   }
  // }, [product]);

  let selectTemplateValue = null

  if (
    metafield &&
    metafield.reference &&
    metafield.reference.fields &&
    metafield.reference.fields.length > 0
  ) {
    selectTemplateValue = metafield.reference.fields[0].value
  }

  const converge = useSeekaConverge()

  useEffect(() => {
    // Execute the viewProduct function with the product data
    if (typeof window !== "undefined") {
      const product = data.storefront.products.nodes.find(
        (node) => node.handle === pageContext.handle
      )

      if (!product) {
        console.error("Product not found.")
        return
      }

      // Extract relevant product data
      const { title, variants, vendor, totalInventory } = product

      // Assuming there's only one variant for simplicity, you might need to adjust this
      const variant = variants.nodes[0]
      const productIdentifier = product.id.replace("gid://shopify/Product/", "")
      const variantIdentifier = variant.id.replace(
        "gid://shopify/ProductVariant/",
        ""
      )

      // Define the data to pass to converge.track.viewProduct()
      const productData = {
        currencyCode: "SGD",
        productIdentifier: productIdentifier,
        variantIdentifier: variantIdentifier,
        sku: variant.sku,
        lineItemIdentifier: "",
        productName: title,
        // variantName: variant.title,
        categoryName: selectTemplateValue,
        brandName: vendor,
        unitPrice: product.priceRange.maxVariantPrice.amount,
        // quantity: 1,
        totalInventory: product.totalInventory,
        totalDiscount: 0,
      }

      // Execute the viewProduct function with the product data
      converge.track.viewProduct(productData)
    }
  }, [data, pageContext, converge])

  const [showFullDescription, setShowFullDescription] = useState(false)

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription)
  }

  const isEcommerceEnabled =
    product.metafield?.reference?.fields[0]?.value === "Ecommerce" ||
    product.metafield?.reference?.fields[0]?.value ===
      "Gallery-Ecommerce-Checkout"

  const canDisplayAddToCart =
    isEcommerceEnabled || product.display_add_to_cart?.value === "true"

  return (
    <>
      <Layout>
        <div className={sectionMandatPad}>
          <div className={saumlContainer}>
            <div className={productContainer}>
              <div className={colProduct}>
                {product.images.nodes.length > 0 && (
                  <div className={pdpImageslider}>
                    <Slider {...productSliderSettings} ref={sliderRef1}>
                      {product.images.nodes.map((image, index) => (
                        <div className={testmaincontainer}>
                          <div className={testcontainer}>
                            <img
                              className={test}
                              src={image.url}
                              alt={image.altText || "product image"}
                            />
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}

                {showThumbnailSlider && (
                  <>
                    <br />
                    <br />
                    <Slider
                      {...thumbnailSliderSettings}
                      ref={sliderRef2}
                      className={thumbnailSliderWrapper}
                    >
                      {productImages.map((image, index) => (
                        <div key={index}>
                          <img
                            src={image.url}
                            alt={image.altText || "thumbnail image"}
                            className={imgPad}
                          />
                        </div>
                      ))}
                    </Slider>
                  </>
                )}
              </div>

              <div className={colProduct}>
                <div>
                  {/* <p>Select Template: {selectTemplate}</p> */}
                  {/* <p>{selectTemplateValue}</p> */}
                  <div>
                    {matchingArtists.map(({ node }) => (
                      <div key={node.handle}>
                        <h1 className={PDPAuthor}>{node.artistname.value}</h1>
                      </div>
                    ))}

                    <h2 className={ArtworkName}>{product.title}</h2>

                    {product.subheading &&
                      product.subheading.reference &&
                      product.subheading.reference.fields[0]?.value && (
                        <p className={pdpSubheading}>
                          {product.subheading.reference.fields[0].value}
                        </p>
                      )}

                    {/* {product.variants && product.variants.nodes[0] && product.variants.nodes[0]?.sku.length > 0 && (
                        <p>SKU: {product.variants.nodes[0].sku}</p>
                      )} */}

                    {product.metafield?.reference?.fields[0]?.value ===
                      "Advisory" ||
                    product.metafield?.reference?.fields[0]?.value ===
                      "Advisory-Hidden" ? (
                      ""
                    ) : (
                      <>
                        {/* Render the price if inventory is not zero */}
                        {product.totalInventory !== 0 &&
                          product.priceRange &&
                          product.priceRange.maxVariantPrice && (
                            <p>
                              $
                              {new Intl.NumberFormat("en-US", {
                                currency:
                                  product.priceRange.maxVariantPrice
                                    .currencyCode,
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }).format(
                                product.priceRange.maxVariantPrice.amount
                              )}{" "}
                              SGD
                            </p>
                          )}
                        {/* Render "Sold" if totalInventory is zero */}
                        {product.totalInventory === 0 && (
                          <p className={soldOut}>Sold</p>
                        )}
                      </>
                    )}

                    {/* 
                            hide add to cart for AdAvisory, Advisory-Hidden and Gallery.
                          */}
                    <>
                      {canDisplayAddToCart ? (
                        <div>
                          <NumericInput
                            aria-label="Quantity"
                            onIncrement={() =>
                              setQuantity((q) => Math.min(q + 1, 2))
                            }
                            onDecrement={() =>
                              setQuantity((q) => Math.max(1, q - 1))
                            }
                            onChange={(event) =>
                              setQuantity(event.currentTarget.value)
                            }
                            value={quantity}
                            min="1"
                            max="2"
                            product={product}
                            title={product.title}
                            vendor={product.vendor}
                            sku={product.variants.nodes[0].sku}
                            unitPrice={
                              product.priceRange.maxVariantPrice.amount
                            }
                            categoryName={selectTemplateValue}
                          />
                          &nbsp; &nbsp; &nbsp;
                          <div className={AddToCartContainer}>
                            <AddToCart
                              variantId={product.variants.nodes[0].id}
                              quantity={quantity}
                              available={product.availableForSale}
                              product={product}
                              title={product.title}
                              vendor={product.vendor}
                              sku={product.variants.nodes[0].sku}
                              unitPrice={
                                product.priceRange.maxVariantPrice.amount
                              }
                              categoryName={selectTemplateValue}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>

                    <div>
                      {product.metafield?.reference?.fields[0]?.value ===
                        "Advisory" ||
                      product.metafield?.reference?.fields[0]?.value ===
                        "Advisory-Hidden" ? (
                        <>
                          <hr className={hrSpec} />
                          <br />
                          <AdvisoryFormLightbox
                            productImage={product.images.nodes[0]?.url}
                            altText={product.images.nodes[0]?.altText}
                            artworkName={product.title}
                            vendorName={product.vendor}
                            skuCode={product.variants.nodes[0].sku}
                          />
                        </>
                      ) : (
                        <>
                          <hr className={hrSpec} />
                          <br />
                          <GalleryFormLightbox
                            productImage={product.images.nodes[0]?.url}
                            altText={product.images.nodes[0]?.altText}
                            artworkName={product.title}
                            vendorName={product.vendor}
                            skuCode={product.variants.nodes[0].sku}
                          />
                          <br />
                        </>
                      )}

                      {product.metafield?.reference?.fields[0]?.value ===
                        "Advisory" ||
                      product.metafield?.reference?.fields[0]?.value ===
                        "Advisory-Hidden" ? (
                        <>
                          {metafield && metafield.reference && (
                            <>
                              <p className={specification}>
                                Discover more with: <em>Art Works Advisory</em>{" "}
                                &nbsp;
                                <span className={tooltip}>
                                  <img
                                    src="https://cdn.shopify.com/s/files/1/0823/1606/7107/files/Tooltip.svg?v=1709266734"
                                    className={tooltipImage}
                                    alt="tooltip"
                                  />
                                  <span className={tooltiptext}>
                                    Art Works Advisory offers seasoned expertise
                                    and access for sophisticated art collectors
                                    and investors.
                                  </span>
                                </span>
                              </p>
                            </>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    <hr className={hrSpec} />

                    {product.dimension &&
                      product.dimension.reference &&
                      product.dimension.reference.fields[0]?.value && (
                        <p>{product.dimension.reference.fields[0].value}</p>
                      )}

                    {product.medium &&
                      product.medium.references &&
                      product.medium.references.nodes.length > 0 && (
                        <div>
                          <p>
                            {product.medium.references.nodes.map(
                              (medium, index, array) => (
                                <React.Fragment key={index}>
                                  <span>{medium.fields[0].value}</span>
                                  {index < array.length - 2 ? ", " : ""}
                                  {index === array.length - 2 &&
                                  array.length > 1
                                    ? " and "
                                    : ""}
                                </React.Fragment>
                              )
                            )}
                          </p>
                        </div>
                      )}

                    {product.artworksubstrate &&
                      product.artworksubstrate.reference &&
                      product.artworksubstrate.reference.fields[0]?.value && (
                        <p>
                          {product.artworksubstrate.reference.fields[0].value}
                        </p>
                      )}

                    {product.metafield?.reference?.fields[0]?.value ===
                      "Advisory" ||
                    product.metafield?.reference?.fields[0]?.value ===
                      "Advisory-Hidden" ? (
                      ""
                    ) : (
                      <>
                        {product.Locationview.map(
                          (location) =>
                            location &&
                            location.reference &&
                            location.reference.fields && (
                              <div key={location.id}>
                                {location.reference.fields.map((field) => (
                                  <React.Fragment key={field.id}>
                                    {field.value === "Online Only" ? (
                                      // If the field value is "Online Only", create a hyperlink with the URL and add "available"
                                      <>
                                        <span>Available </span>
                                        {/* <a href={location.reference.fields.find(f => f.value.includes("http"))?.value} target="_blank" rel="noopener noreferrer" className={pdpUrl}> */}
                                        {field.value}
                                        {/* </a> */}
                                      </>
                                    ) : // For other values, check if it's "One Holland Village"
                                    field.value === "One Holland Village" ? (
                                      // If the field value is "One Holland Village", create a hyperlink with the URL and add "available at"
                                      <>
                                        <span>Available at </span>
                                        <Link
                                          to={
                                            location.reference.fields.find(
                                              (f) => f.value.includes("http")
                                            )?.value
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className={pdpUrl}
                                        >
                                          {field.value}
                                        </Link>
                                      </>
                                    ) : (
                                      // Otherwise, display the value normally
                                      ""
                                    )}
                                  </React.Fragment>
                                ))}
                              </div>
                            )
                        )}
                      </>
                    )}

                    {matchingArtists.map(({ node }) => (
                      <div key={node.handle}>
                        <br />
                        <br />
                        <ProductButton to={`/artists/${node.handle}`}>
                          View Artist
                        </ProductButton>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* {product.media && product.media.nodes.length > 0 && (
        <div className={saumlContainer}>
         <h1 className={title}>Media</h1> 
          <div className={containerMedia}>
            {product.media.nodes.map((mediaNode, index) => (
              <div key={index}>
                {mediaNode.previewImage && mediaNode.previewImage.src && (
                  <img
                    src={mediaNode.previewImage.src}
                    alt={`Preview Image ${index}`}
                    style={{ maxWidth: '100%', height: 'auto' }}
                  />
                )}
                {mediaNode.sources && mediaNode.sources.length > 0 && mediaNode.sources[0].url && (
                  <>
                    {mediaNode.sources.map((source, sourceIndex) => (
                      <div key={sourceIndex}>
                        {source.format === 'usdz' ? (
                          <a href={source.url} rel="ar">
                            Open in AR
                          </a>
                        ) : (''
                          <iframe
                            title={`3D Model ${index}`}
                            src={source.url}
                            width="100%"
                            height="400px"
                          ></iframe>
                        )}
                      </div>
                    ))}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )} */}

          {product.descriptionHtml && product.descriptionHtml.length > 0 && (
            <div className={saumlContainer}>
              <h1 className={title}>ARTWORK DESCRIPTION</h1>
              <ShopifyRichText richTextData={product.descriptionHtml} />
            </div>
          )}

          {matchingArtists.length > 0 && (
            <div className={saumlContainer}>
              <h1 className={title}>ARTIST BIO</h1>
              {/* <div>
          {matchingArtists.map(({ node }) => (
          <div key={node.handle}>
          {node.artistdescription && (
            <div>
              <ShopifyRichText richTextData={node.artistdescription.value} />
              <DarkButton className={bluedDarkbutton} to={`/artists/${node.handle}`}>
                    READ MORE &rarr;
                  </DarkButton>
            </div>
          )}
          </div>
        ))}
          </div> */}
              <div>
                {matchingArtists.map(({ node }) => (
                  <div key={node.handle}>
                    {node.artistdescription && (
                      <div>
                        <div
                          style={{
                            overflow: "hidden",
                            maxHeight: showFullDescription ? "none" : "160px",
                            transition: "max-height 0.5s ease-out",
                            position: "relative",
                          }}
                        >
                          <ShopifyRichText
                            richTextData={node.artistdescription.value}
                          />
                          {!showFullDescription && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                width: "100%",
                                height: "10%", // Adjust the height of the gradient to control fade length
                                background: `linear-gradient(0deg, rgb(255 255 255) 49%, rgb(255 255 255 / 0%))`,
                                backgroundImage: `linear-gradient(0deg, rgb(255 255 255 / 0%) 49%, rgb(0 212 255 / -20%) 100%) rgb(255 255 255 / 40%)`, // Adjust opacity here
                              }}
                            ></div>
                          )}
                        </div>
                        {node.artistdescription.value.split(/\s+/).length >
                          20 && (
                          <DarkButton
                            className={bluedDarkbutton}
                            onClick={toggleDescription}
                          >
                            {showFullDescription
                              ? "Read Less ↑"
                              : "Read More ↓"}
                          </DarkButton>
                        )}
                        <div>
                          <DarkButton
                            className={bluedDarkbutton}
                            to={`/artists/${node.handle}`}
                          >
                            VISIT ARTIST PROFILE &rarr;
                          </DarkButton>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {productMetafields && productMetafields.length > 0 && (
          <div className={saumlContainer}>
            <h1 className={title}>WHAT ART WORKS SAY</h1>
            <div className={containerMedia}>
              <div className={colMedia}>
                {productMetafields.map(
                  (metafield) =>
                    metafield &&
                    metafield.reference && (
                      <div key={metafield.id}>
                        <ShopifyRichText
                          richTextData={metafield.reference.fields[0]?.value}
                        />
                      </div>
                    )
                )}
              </div>
              <div className={colMedia}>
                {productMetafields.map(
                  (metafield) =>
                    metafield &&
                    metafield.reference && (
                      <div key={metafield.id}>
                        {metafield.reference.fields.some(
                          (field) =>
                            field.reference &&
                            field.reference.id.includes("MediaImage")
                        ) && (
                          <div>
                            <img
                              src={
                                metafield.reference.fields.find(
                                  (field) =>
                                    field.reference &&
                                    field.reference.id.includes("MediaImage")
                                ).reference.image.url
                              }
                              alt=""
                            />
                          </div>
                        )}
                        {metafield.reference.fields.some(
                          (field) =>
                            field.reference &&
                            field.reference.id.includes("Video")
                        ) && (
                          <div>
                            <video controls>
                              <source
                                src={
                                  metafield.reference.fields.find(
                                    (field) =>
                                      field.reference &&
                                      field.reference.id.includes("Video")
                                  ).reference.sources[0].url
                                }
                                type="video/mp4"
                                alt={
                                  metafield.reference.fields.find(
                                    (field) =>
                                      field.reference &&
                                      field.reference.id.includes("Video")
                                  ).reference.alt
                                }
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        )}

        {/* <Guide grayBackground={true} /> */}

        {data.storefront.products.nodes
          .filter(
            (product) =>
              product.vendor === productVendor &&
              product.handle !== pageContext.handle
          )
          .filter(
            (product) =>
              product.metafield?.reference?.fields[0]?.value !==
              "Advisory-Hidden"
          ).length > 0 && (
          <div className={`${saumlContainer} ${sPad}`}>
            <h1 className={title}>OTHER WORKS BY THE ARTIST</h1>
            <div>
              <Slider {...sliderSettings}>
                {data.storefront.products.nodes
                  .filter(
                    (product) =>
                      product.vendor === productVendor &&
                      product.handle !== pageContext.handle
                  )
                  .map((product) => {
                    // Check if the product should be hidden
                    if (
                      product.metafield?.reference?.fields[0]?.value ===
                      "Advisory-Hidden"
                    ) {
                      return null // Skip rendering this product
                    }
                    return (
                      <Link to={getProductLink(product)} key={product.handle}>
                        <div
                          className={SliderContainer}
                          style={sliderContainerStyle}
                        >
                          <img
                            src={product.images.nodes[0]?.url}
                            className={artworkImages}
                            alt={
                              product.images.nodes[0]?.altText ||
                              "Product Image"
                            }
                          />
                          <p className={mandatpad}>{product.title}</p>
                        </div>
                      </Link>
                    )
                  })}
              </Slider>
            </div>
          </div>
        )}

        {randomArtists.length > 0 ? (
          <div className={emaContainer}>
            <h1 className={title}>SIMILAR ARTISTS YOU MAY LIKE</h1>
            <div>
              <div className={listingContainerStyle}>
                {randomArtists.map(({ node }) => (
                  <div key={node.handle} className={artistItem}>
                    <Link to={`/artists/${node.handle}`}>
                      {node.field && node.field.reference && (
                        <img
                          className={artistImage}
                          src={node.field.reference.image.url}
                          alt={node.field.reference.image.altText}
                        />
                      )}
                      <br />
                      <h3 className={subsectionTitles}>
                        {node.fields.find(
                          (field) => field.key === "artist_name"
                        )?.value || ""}
                      </h3>
                      <DarkButton
                        className={blueDarkbutton}
                        to={`/artists/${node.handle}`}
                      >
                        View artist and works
                      </DarkButton>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </Layout>
    </>
  )
}

export const Head = ({ data, pageContext }) => {
  const product = data.storefront.products.nodes.find(
    (node) => node.handle === pageContext.handle
  )

  return <Seo title={product.title} />
}

export const query = graphql`
  query SingleProduct {
    storefront {
      products(first: 250) {
        nodes {
          handle
          descriptionHtml
          createdAt
          availableForSale
          id
          isGiftCard
          onlineStoreUrl
          publishedAt
          requiresSellingPlan
          tags
          title
          totalInventory
          vendor
          images(first: 250) {
            nodes {
              height
              url
              altText
            }
          }
          media(first: 250) {
            nodes {
              ... on Storefront_Model3d {
                id
                sources {
                  format
                  url
                }
                previewImage {
                  src
                }
              }
            }
          }
          variants(first: 1) {
            nodes {
              sku
              id
            }
          }
          priceRange {
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          subheading: metafield(
            key: "product_subheading"
            namespace: "custom"
          ) {
            value
            updatedAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          advisoryInformation: metafields(
            identifiers: { key: "advisory_information", namespace: "custom" }
          ) {
            id
            reference {
              ... on Storefront_Metaobject {
                id
                framingData: field(key: "framing_data") {
                  value
                }
                valuationsData: field(key: "valuations_data") {
                  value
                }
                managementFeeData: field(key: "management_fees_data") {
                  value
                }
                valueOfWorkData: field(key: "value_of_work_data") {
                  value
                }
                totalCostofPortfolioIncludingSundriesData: field(
                  key: "total_cost_of_portfolio_including_sundries_data"
                ) {
                  value
                }
                rentalTermsData: field(key: "rental_terms") {
                  value
                }
                rentalreturnData: field(key: "rental_returns") {
                  value
                }
              }
            }
          }
          medium: metafield(key: "artwork_medium", namespace: "custom") {
            references(first: 250) {
              nodes {
                ... on Storefront_Metaobject {
                  id
                  fields {
                    value
                  }
                }
              }
            }
          }
          display_add_to_cart: metafield(
            key: "display_add_to_cart"
            namespace: "custom"
          ) {
            value
          }
          artworksubstrate: metafield(
            key: "artwork_substrate"
            namespace: "custom"
          ) {
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          dimension: metafield(key: "product_dimensions", namespace: "custom") {
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          Locationview: metafields(
            identifiers: {
              key: "where_is_artwork_available_to_view_"
              namespace: "custom"
            }
          ) {
            id
            createdAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          metafield(key: "select_template", namespace: "custom") {
            value
            updatedAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          metafields(
            identifiers: [{ namespace: "custom", key: "what_artworks_says" }]
          ) {
            createdAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  reference {
                    ... on Storefront_Video {
                      id
                      sources {
                        url
                      }
                      alt
                    }
                    ... on Storefront_MediaImage {
                      id
                      image {
                        url
                        altText
                      }
                    }
                  }
                  value
                }
              }
            }
          }
        }
      }
      collections(first: 250) {
        nodes {
          descriptionHtml
          id
          title
          handle
          image {
            url
            altText
          }
          metafields(
            identifiers: [
              { namespace: "custom", key: "explore_artist_by" }
              { namespace: "custom", key: "artist_format" }
              { namespace: "custom", key: "artist_career_stages" }
              { namespace: "custom", key: "artist_region" }
              { namespace: "custom", key: "collection_related_to_artist" }
              { namespace: "custom", key: "similar_artists" }
              { namespace: "custom", key: "is_this_an_artist_collection" }
              { namespace: "custom", key: "auction_results" }
              { namespace: "custom", key: "pdf" }
            ]
          ) {
            namespace
            key
            value
            references(first: 250) {
              nodes {
                ... on Storefront_Metaobject {
                  handle
                  fields {
                    value
                  }
                }
              }
            }
            reference {
              ... on Storefront_Metaobject {
                handle
                field(key: "artists_photo") {
                  reference {
                    ... on Storefront_MediaImage {
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
                pdfFile: field(key: "pdf") {
                  key
                  reference {
                    ... on Storefront_GenericFile {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
      metaobjects(first: 250, type: "artists_list") {
        edges {
          node {
            handle
            fields {
              value
              type
              key
            }
            field(key: "artist_featured_photo") {
              value
              key
              reference {
                ... on Storefront_MediaImage {
                  id
                  image {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
              }
            }
            artistname: field(key: "artist_name") {
              value
              key
              reference {
                ... on Storefront_Metaobject {
                  id
                  handle
                  fields {
                    value
                  }
                }
              }
            }
            artistdescription: field(key: "artists_description") {
              value
              key
              reference {
                ... on Storefront_Metaobject {
                  id
                  handle
                  fields {
                    value
                  }
                }
              }
            }
            bioimages: field(key: "artistimages") {
              value
              key
              references(first: 10) {
                nodes {
                  ... on Storefront_MediaImage {
                    id
                    image {
                      altText
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
